<template>
    <q-page>
        <div class="q-display-2">Materiały audio</div>
        <upload @uploaded="uploaded"/>

        <div>
            <audio-viewer
                class="audio"
                :inline="true"
                v-for="item in items"
                :key="item.id"
                :model="item"
                :deletable="true">
            </audio-viewer>
        </div>
    </q-page>
</template>

<script>
    import Item from 'quasar-framework/src/mixins/item'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import Upload from './Upload'
    import AudioViewer from './pole/viewers/AudioViewer'
    import UploadInvisible from './UploadInvisible'

    export default {
        name: 'Audio',
        components: {UploadInvisible, AudioViewer, Upload, QCardActions, QInput, Item},
        data () {
            return {
                loading: false,
                editableItem: undefined,
                columns: [
                    {
                        field: 'name',
                        name: 'name',
                        label: 'Nazwa',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        name: 'options',
                    },
                ],
            }
        },
        methods: {
            fetch () {
                this.$store.dispatch('fetchAll', {
                    what: 'file'
                })
            },
            uploaded () {

            },
        },
        mounted () {
            this.fetch()
        },
        computed: {
            items() {
                return this.$store.getters.audio
            },
        },
    }
</script>

<style scoped lang="scss">
    .audio {
        width: 250px;
    }
</style>